<template>
  <q-chip
    clickable
    square
    :color="color"
    :text-color="textColor"
    :label="item.state ? $_.startCase(item.state) : '<unknown>'"
  />
</template>

<script>

export default {
  name: 'OrderStateCell',
  props: {
    props: {
      type: Object,
      required: true
    }
  },
  computed: {
    item () {
      return this.props.row
    },
    color () {
      if (this.item.state === 'complete' || this.item.state === 'completed' || this.item.state === 'placed') {
        return 'indigo-2'
      } else if (this.item.state === 'open_tab') {
        return 'positive'
      } else if (this.item.state === 'valid') {
        return 'grey'
      } else if (this.item.state === 'voided' || this.item.state === 'refunded') {
        return 'negative'
      } else if (this.item.state === 'canceled') {
        return 'negative'
      } else if (this.item.state === 'partially_voided' || this.item.state === 'partially_refunded') {
        return 'warning'
      } else if (this.item.state === 'pending') {
        return 'warning'
      } else {
        return null
      }
    },
    textColor () {
      if (this.item.state === 'complete' || this.item.state === 'completed' || this.item.state === 'placed') {
        return 'dark'
      } else if (this.item.state === 'open_tab') {
        return 'white'
      } else if (this.item.state === 'voided' || this.item.state === 'refunded') {
        return 'white'
      } else if (this.item.state === 'canceled') {
        return 'white'
      } else if (this.item.state === 'partially_voided' || this.item.state === 'partially_refunded') {
        return 'white'
      } else if (this.item.state === 'valid') {
        return 'white'
      } else if (this.item.state === 'draft') {
        return 'grey-6'
      } else {
        return 'dark'
      }
    }
  }
}

</script>
